/**
 * THIS FILE IS AUTOGENERATED, DO NOT EDIT IT!
 */
import { api } from '../../../config/api';

import type { CommunicationChannelsData } from '../types';

const injectedRtkApi = api.injectEndpoints({
  endpoints: (build) => ({
    getSettingsCommunicationChannels: build.query<CommunicationChannelsData, void>({
      query: () => ({ method: 'GET', url: `/v1/settings/communication-channels` }),
    }),
  }),
  overrideExisting: true,
});

export { injectedRtkApi as getSettingsCommunicationChannelsApi };
export const { useGetSettingsCommunicationChannelsQuery, useLazyGetSettingsCommunicationChannelsQuery } =
  injectedRtkApi;
